import { render } from "./Logger.vue?vue&type=template&id=5e4e0a98&scoped=true"
import script from "./Logger.vue?vue&type=script&lang=js"
export * from "./Logger.vue?vue&type=script&lang=js"

import "./Logger.vue?vue&type=style&index=0&id=5e4e0a98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4e0a98"]])

export default __exports__